import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Particle from "../../Particle";
import projectData from "../../components/Projects/projectData";
import ProjectCards from "../../components/Projects/ProjectCards";

export default function ProjectPage() {
  if (!Array.isArray(projectData)) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">
            Unable to retrieve project data.
          </h1>
        </Container>
      </Container>
    );
  }

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Selected <strong className="purple">Works </strong>
        </h1>
        <p className="project-subheading">
          A showcase of my recent professional projects and applications.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectData.map((item, index) => (
            <Col key={index} lg={4} md={6} className="project-card">
              <ProjectCards
                isBlog={item.isBlog}
                title={item.title}
                subtitle={item.subtitle}
                description={item.description}
                ghLink={item.ghLink}
                demoLink={item.demoLink}
                appStoreLink={item.appStoreLink}
                techStack={item.techStack}
                noGithub={item.noGithub}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}
